const isSingapore = false
module.exports = isSingapore



// WEBPACK FOOTER //
// ./src/setting.js